const common: Record<string, string> = {
  "site.name": "妖精视频",
  "site.slogan": "水果植物系列 · 高清免费在线观看",
  "site.description": "妖精视频水果植物系列，汇集香蕉视频、蜜桃视频、西瓜视频、樱花视频等热门平台，高清免费在线观看。",
  "nav.home": "首页",
  "nav.about": "关于我们",
  "nav.search": "搜索视频...",
  "nav.allVideos": "全部视频",
  "footer.rights": "© 2024 妖精视频 版权所有 | 妖精视频水果植物系列",
  "footer.sitemap": "网站地图",
  "footer.disclaimer": "免责声明",
  "footer.privacy": "隐私政策",
  "footer.terms": "用户协议",
  "category.all": "全部",
  "category.sort": "排序",
  "category.hot": "最热",
  "category.new": "最新",
  "category.mostViews": "最多播放",
  "category.quality": "画质",
  "category.noResults": "没有找到相关视频",
  "category.noResultsHint": "试试其他关键词或分类",
  "category.results": "共找到 {count} 部视频",
};

export default common;